import * as Text from 'shared/utils/Text';

import MomentDate from './MomentDate';

const padLeft = function (str_, pad, length) {
  let str = String(str_);
  while (str.length < length) {
    str = pad + str;
  }
  return str;
};

export const debug = function () {
  window.console && window.console.log.apply(console, arguments);
};

export const sprite = function (id) {
  return window.$('<span class="sprite"/>').addClass(id);
};

export const callDelegate = function (delegate, method) {
  if (!delegate) {
    debug(`No delegate for receiving: ${method}`);
  } else if (!delegate[method]) {
    debug(`Not implemented: ${method}`, delegate);
  } else {
    const a = [];
    for (let i = 2; i < arguments.length; i++) {
      a.push(arguments[i]);
    }

    return delegate[method].apply(delegate, a);
  }
};

export const compactPercent = function (value, needSign = true) {
  let str = String(Math.round(value));

  if (str.length < 2 || (str.length === 2 && value < 0)) {
    str = String(Math.round(value * 10) / 10);
  }

  if (needSign) {
    str += '%';
  }

  return str;
};

// TODO - deperecated, see dateUtils
export const time = function (date, raw) {
  if (!date) {
    return '-';
  }

  let str = `${padLeft(date.getHours(), '0', 2)}:${padLeft(
    date.getMinutes(),
    '0',
    2,
  )}`;

  if (!raw) {
    str = Text.get('general-time', str);
  }

  return str;
};

// TODO - move to date util, use moment.format
export const timeString = function (date) {
  const d = date ? date : new MomentDate();

  return `${padLeft(d.getHours(), '0', 2)}:${padLeft(
    d.getMinutes(),
    '0',
    2,
  )}:${padLeft(d.getSeconds(), '0', 2)}`;
};

// TODO - deperecated, see dateUtils
export const formatDateCompact = function (date) {
  const d = date ? date : new MomentDate();

  const year = String(d.getFullYear()).slice(2);
  const month = d.getMonth() + 1;
  const day = d.getDate();

  return padLeft(year, '0', 2) + padLeft(month, '0', 2) + padLeft(day, '0', 2);
};

// TODO - deperecated, see dateUtils
export const formatDate = function (date) {
  if (date == null) {
    console.warn(`Expected date instance to format but got '${date}'`);
    return '';
  }
  return Text.get(
    'general-date',
    date.getDate(),
    Text.get(`month_${date.getMonth() + 1}`),
  );
};

// TODO - deperecated, see dateUtils
export const formatDateTime = function (date) {
  if (date == null) {
    console.warn(`Expected date instance to format but got '${date}'`);
    return '';
  }
  return Text.get(
    'general-date-time',
    formatDate(date),
    time(date).toLowerCase(),
  );
};

export const insertTexts = function ($target) {
  $target
    .find('[class]')
    .addBack('[class]')
    .each(function () {
      const $this = window.$(this);
      let cs = $this.attr('class');
      cs = cs.length > 0 ? cs.split(' ') : [];

      for (const c of cs) {
        if (Text.hasText(c)) {
          $this.html(Text.get(c));
        }
      }
    });
};

export const getEventPosition = function (e, positionType) {
  // fix for Firefox, no event for mobile emulator is being sent
  let o = { x: 0, y: 0 };

  if ('touches' in e.originalEvent) {
    if (e.originalEvent.touches && e.originalEvent.touches.length > 0) {
      o = e.originalEvent.touches[0];
    } else if (
      e.originalEvent.changedTouches &&
      e.originalEvent.changedTouches.length > 0
    ) {
      o = e.originalEvent.changedTouches[0];
    }
  } else if (e) {
    o = e;
  }

  if (positionType === 'client') {
    return { x: o.clientX, y: o.clientY };
  } else if (positionType === 'screen') {
    return { x: o.screenX, y: o.screenY };
  } else {
    return { x: o.pageX, y: o.pageY };
  }
};

export const getEventTouchCount = function (e) {
  return 'touches' in e.originalEvent ? e.originalEvent.touches.length : 1;
};

export const positionsAreCloser = function (p1, p2, limit) {
  const dX = p1.x - p2.x;
  const dY = p1.y - p2.y;
  const d2 = dX * dX + dY * dY;
  const limit2 = limit * limit;

  return d2 < limit2;
};

export const positionsAreFurther = function (p1, p2, limit) {
  return !positionsAreCloser(p1, p2, limit);
};

export const calcDistance = function (x1, y1, x2, y2) {
  const a = x1 - x2;
  const b = y1 - y2;
  return Math.hypot(a, b);
};

export const clone = function (o) {
  return JSON.parse(JSON.stringify(o));
};

export const wrapRaceNumber = function (v) {
  return ((v - 1) % 12) + 1;
};

export const shortenString = function (str, max) {
  return str.length > max ? `${str.slice(0, Math.max(0, max))}…` : str;
};

export const negativeBlankToValue = function (v, m) {
  const min = m != null ? m : -1;
  return v <= min ? '' : v;
};

export const valueToNegativeBlank = function (v) {
  return v === '' ? -1 : v;
};

export const isModifierKeyPressed = function (event) {
  return navigator.userAgent.includes('Mac OS X')
    ? event && event.metaKey
    : event && event.ctrlKey;
};
